import React from 'react';
import Successful from '../../icons/Successful';
import styled from 'styled-components';
import { Button } from '../ui';

interface Props {
  title: string;
  message: string;
  buttonText?: string;
  handleClick?: () => void;
}

const Success: React.FC<Props> = ({ title, message, buttonText, handleClick }) => {
  return (
    <div className="flex flex-col items-center mb-8">
      <StyledSuccessfulIconWrapper>
        <Successful />
      </StyledSuccessfulIconWrapper>

      <StyledTitle className="mt-6">{title}</StyledTitle>

      {message && <StyledText className="mb-8">{message}</StyledText>}
      {buttonText && (
        <StyledButton className="w-48 mx-2" type="button" onClick={handleClick} variant="outlined">
          {buttonText}
        </StyledButton>
      )}
    </div>
  );
};

export default Success;

const StyledSuccessfulIconWrapper = styled.div`
  svg {
    width: 6rem;
  }
`;
const StyledTitle = styled.h2`
  font-size: 2.8rem;
  font-weight: 700;
  text-align: center;
`;
const StyledText = styled.p`
  font-size: 1.1rem;
  text-align: center;
  margin-top: 0.5rem;
`;
const StyledButton = styled(Button)`
  font-size: 1rem;
  border-width: 2px;
  width: 14rem;
`;
